export default __webpack_public_path__ + "static/media/Marquise@2x.170236c4.png";